import React from 'react'
import PropTypes from 'prop-types'
import { Button, Flex, Copy, Icon, themeColor } from '@elparking/components'
import styled from 'styled-components'

import { FormattedMessage } from 'react-intl'

export const TabButton = styled(Button.unstyled)`
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: ${({active}) => active ? `4px solid` : `4px solid transparent`};
    color: ${({active}) => active ? themeColor('main') : themeColor('gray')};
    width: 100%;
    padding-bottom: 1em;
`

export const AIRPORT = 'airport'
export const ALL_PLACES = 'allPlaces'

const TabFilterMobile = ({selected, onClickTab}) => (
    <Flex w='100%' justifyContent='space-around'>
        <TabButton onClick={() => { onClickTab(ALL_PLACES) }} active={selected === ALL_PLACES}>
            <Icon size='xLarge' type='parking-signal' color='inherit' />
            <Copy size='xxSmall' color='inherit' padding='0 0 0 0.5em' fontWeight={selected === ALL_PLACES ? 'book' : 'regular'}>
                <FormattedMessage
                  defaultMessage='Todos los parkings'
                />
            </Copy>
        </TabButton>
        <TabButton onClick={() => { onClickTab(AIRPORT) }} active={selected === AIRPORT}>
            <Icon size='xLarge' type='plane-signal' color='inherit' />
            <Copy size='xxSmall' color='inherit' padding='0 0 0 0.5em' fontWeight={selected === AIRPORT ? 'book' : 'regular'}>
                <FormattedMessage
                  defaultMessage='Aeropuertos'
                />
            </Copy>
        </TabButton>
    </Flex>
)

TabFilterMobile.propTypes = {
    selected: PropTypes.string,
    onClickTab: PropTypes.func,
}

TabFilterMobile.defaultProps = {
    selected: ALL_PLACES,
}

export default TabFilterMobile
